"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _shared = _interopRequireDefault(require("../../Tooltip/shared"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  types: {
    /**
     * Whether the English or French copy will be used (e.g. for accessibility labels).
     */
    copy: _propTypes.default.oneOf(['en', 'fr']),
    /**
     * The input label.
     */
    label: _propTypes.default.string,
    /**
     * A short description of the expected input.
     */
    hint: _propTypes.default.string,
    /**
     * Position of the hint relative to label. Use `below` to display a larger hint below the label.
     */
    hintPosition: _propTypes.default.oneOf(['inline', 'below']),
    /**
     * A detailed description of validation error/success or additional instructions.
     * Visual variant is determined based on the `validation` prop.
     */
    feedback: _propTypes.default.string,
    /**
     * Tokens to be passed to the feedback component.
     */
    feedbackTokens: _propTypes.default.object,
    /**
     * Props to be passed to the feedback component.
     */
    feedbackProps: _propTypes.default.object,
    /**
     * an optional `Tooltip`. If set, tooltip will be shown next to the label.
     * Props can be passed to the tooltip in one of the following ways.
     * 1. `tooltip` as a string - The content of the tooltip.
     * 2. `tooltip` as an object - Tooltip component props to be passed.
     */
    tooltip: _propTypes.default.oneOfType([_shared.default, _propTypes.default.string]),
    /**
     * Use to visually mark an input as valid or invalid.
     */
    validation: _propTypes.default.oneOf(['error', 'success']),
    /**
     * The text value from an input field.
     */
    inputValue: _propTypes.default.string,
    /**
     * Max number of characters allowed id an input text.
     */
    maxCharacterAllowed: _propTypes.default.number
  },
  select: _ref => {
    let {
      copy,
      label,
      hint,
      hintPosition,
      feedback,
      feedbackTokens,
      feedbackProps,
      tooltip,
      validation,
      inputValue,
      maxCharacterAllowed
    } = _ref;
    return {
      supportsProps: {
        copy,
        label,
        hint,
        hintPosition,
        feedback,
        feedbackTokens,
        feedbackProps,
        tooltip,
        validation,
        inputValue,
        maxCharacterAllowed
      }
    };
  }
};